module.exports = __webpack_public_path__ + "static/media/backsky2.5cb661db.jpg";